import React from "react";

import { Box, Flex, Text } from "@chakra-ui/react";

import Group from "../../../pages/ServicosAcolhimento/Visualizar/Group";
import { TableEducacao } from "../../TableEducacao";
import Information from "../../../pages/ServicosAcolhimento/Visualizar/Information";
import { IconeDownload } from "../../IconeDownload";

export const Saude = ({ data }) => {
  const columns = [
    {
      Header: "Problema de Saúde",
      accessor: "doenca",
      Cell: (props) => {
        const doenca = props?.value;

        return <span>{doenca.descricao ? doenca.descricao : ""}</span>;
      },
    },
    {
      Header: "Faz Algum Tratamento de Saúde?",
      accessor: "fazTratamento",
      Cell: (props) => {
        const tratamento =
          props?.value === "S"
            ? "Sim"
            : props?.value === "T"
            ? "Sim (Temporário)"
            : props?.value === "P"
            ? "Sim (Permanente)"
            : "Não";

        return (
          <Flex justifyContent={"center"}>
            {tratamento ? tratamento : "Sim"}
          </Flex>
        );
      },
    },
    {
      Header: "Laudo Médico",
      accessor: (row) => {
        return row;
      },
      Cell: (props) => {
        const laudo = props?.value?.laudoMedico;

        return (
          <Flex justifyContent={"center"}>
            {laudo ? (
              <button type="button">
                <IconeDownload />
              </button>
            ) : (
              ""
            )}
          </Flex>
        );
      },
    },
  ];

  return data ? (
    <Box className="break-page">
      <Flex>
        <Group bgColor="#fff" title="Saúde" py="12px" mtDivider="5px">
          <Box border="solid 1px #DDEBEA" px={2} py={4} mt={2}>
            <Information
              title="Possui deficiência?"
              print={true}
              information={
                data.possuiDeficiencia === "S"
                  ? "Sim. " +
                    (data.deficiencias.length === 0
                      ? ""
                      : data.deficiencias.length === 1
                      ? data.deficiencias[0].descricaoTipoDeficiencia
                      : data.deficiencias.length === 2
                      ? `${data.deficiencias[0].descricaoTipoDeficiencia} e ${data.deficiencias[1].descricaoTipoDeficiencia}`
                      : `${data.deficiencias
                          .map((item) => item.descricaoTipoDeficiencia)
                          .slice(0, -1)
                          .join(", ")} e ${
                          data.deficiencias[data.deficiencias.length - 1]
                            .descricaoTipoDeficiencia
                        }`)
                  : "Não"
              }
              mt="10px"
            />
          </Box>
          <Box border="solid 1px #DDEBEA" px={2} py={4} mt={2}>
            <Information
              print={true}
              title="Possui algum problema de saúde?"
              information={data.possuiProblemasSaude === "S" ? "Sim. " : "Não"}
              mt="10px"
            />
          </Box>
          {data?.possuiProblemasSaude === "S" ? (
            <>
              {data.tratamentos && data.tratamentos.length > 0 && (
                <Box mt={2}>
                  <TableEducacao
                    saude={true}
                    columns={columns}
                    data={data.tratamentos}
                  />
                </Box>
              )}
            </>
          ) : (
            ""
          )}

          <Flex
            justifyContent={"space-between"}
            border="solid 1px #DDEBEA"
            alignItems={"center"}
            px={2}
            py={4}
            mt={2}
          >
            <Information
              print={true}
              title="Possui Cartão de Vacinação?"
              information={
                data?.cartaoVacinacao === "S"
                  ? "Sim"
                  : data?.cartaoVacinacao === "N"
                  ? "Não"
                  : "Sem Informação"
              }
              mt="10px"
            />

            <Flex gap={4} mr={{ base: "15%", xl: "15.5%" }} h={18}>
              <Text fontWeight={600} fontSize="14px">
                Baixar Cartão de Vacinação
              </Text>
              {!data?.anexoCartaoVacinacao ? (
                <button type="button">
                  <IconeDownload />
                </button>
              ) : (
                ""
              )}
            </Flex>
          </Flex>

          {data?.possuiProblemasSaude === "S" ? (
            <Box border="solid 1px #DDEBEA" px={2} py={4} mt={2}>
              <Information
                print={true}
                title="Usa Medicação Contínua?"
                information={data.medicacaoContinua === "S" ? "Sim" : "Não"}
                mt="10px"
              />
            </Box>
          ) : (
            ""
          )}
        </Group>
      </Flex>
    </Box>
  ) : (
    <Box className="break-page">
      <Flex>
        <Group
          bgColor="#fff"
          title="Saúde"
          mt="15px"
          py="12px"
          mtDivider="5px"
        />
      </Flex>
    </Box>
  );
};
